import {
  Linkedin,
  Instagram,
  Facebook,
  Youtube,
  Phone,
  Mail,
  MapPin,
} from "lucide-react";
import CDSCO from "../../../assets/images/Extra/CDSCO.webp";
import StartupIndia from "../../../assets/images/Extra/StartupIndia.webp";
const Footer = () => {
  return (
    <footer className="bg-primary text-gray-300">
      {/* Top section */}
      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-3 gap-10 text-sm">

        {/* Left: Contact info */}
        <div className="space-y-4">
          <div className="flex items-start gap-3">
            <a
              href="tel:+918830540638"
              className="flex items-start gap-3 hover:text-white transition"
            >
              <Phone size={16} className="mt-1" />
              <span>+91 8830540638</span>
            </a>

          </div>

          <div className="flex items-start gap-3">
         
            <span><a
              href="mailto:info@sacrum3d.com"
              className="flex items-start gap-3 hover:text-white transition"
            >
              <Mail size={16} className="mt-1" />
              <span>info@sacrum3d.com</span>
            </a>
            </span>
          </div>

          <div className="flex items-start gap-3">
            <MapPin size={16} className="mt-1" />
            <span>
              35, OmBunglow, Phatak Baug, Navi Peth, Sadashiv Peth, Pune, Maharashtra 411030
            </span>
          </div>

          <p className="pt-2">GST No. 27ABLCS2758L1ZN</p>
           <p className="pt-2">CIN U28299PN2023PTC222338</p>
        </div>

        {/* Middle: Help + Certifications */}
        <div className="space-y-6 text-center md:text-left">
          <p>
            Have questions on <strong>SACRUM</strong>? Check the{" "}
            <a href="#" className="underline hover:text-white">FAQs</a> or feel free to contact us.
          </p>

          <p>
            For privacy details,{" "}
            <a href="#" className="underline hover:text-white">
              view our Privacy Policy
            </a>.
          </p>


        </div>

        {/* Right: Supported by */}
        <div className="space-y-2 text-center md:text-left">
          <h4 className="font-semibold text-white">Supported By</h4>
          <div className="flex flex-wrap justify-center md:justify-start gap-4 opacity-90">
            <img src={StartupIndia}
              alt="Startup India"
              className="h-20 invert brightness-0 contrast-100 w-auto object-contain grayscale hover:grayscale-0 transition"
            />

          </div>
           <h4 className="font-semibold text-white">Certifications</h4>
          <div className="flex flex-wrap justify-center md:justify-start gap- opacity-90">
            <img src={CDSCO}
              alt="CDSCO"
              className="h-20 invert brightness-0 contrast-100 w-auto object-contain grayscale hover:grayscale-0 transition"
            />

          </div>
        </div>

         

        

      </div>

      {/* Divider */}
      <div className="border-t border-white/10" />

      {/* Bottom section */}
      <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col items-center gap-4 text-xs text-gray-400">

        {/* Social icons */}
        <div className="flex items-center gap-5">
          <a href="https://www.linkedin.com/company/sacrum-3d/?originalSubdomain=in" aria-label="LinkedIn" className="hover:text-white">
            <Linkedin size={18} />
          </a>
          <a href="https://www.instagram.com/final.whistle.official?igsh=MWVhMGxmYnl4MXV3MA==" aria-label="Instagram" className="hover:text-white">
            <Instagram size={18} />
          </a>
          <a href="https://www.facebook.com/profile.php?id=61557927255264" aria-label="Facebook" className="hover:text-white">
            <Facebook size={18} />
          </a>
           <a href="https://www.youtube.com/@Sacrum3D" aria-label="Youtube" className="hover:text-white">
            <Youtube size={18} />
          </a>
        </div>

        {/* Copyright */}
        <p className="text-center">
          © {new Date().getFullYear()} Sacrum 3D. All rights reserved. <br />
          Developed by{" "}
          <a
  href="https://www.linkedin.com/in/aniket-choudhari-3019121aa"
  target="_blank"
  rel="noopener noreferrer"
  className="text-blue-500 hover:underline"
>
  Aniket Choudhari
</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
